import {
  VyjadreniaAdminCancelApi,
} from 'elegislativa-frontend-ts-axios';
import apiConfiguration from '../configuration/apiConfiguration';
import { ClientResponse } from '../../model/ClientResponse';
import { elegislativaPrefixPath } from '../configuration/apiConfigurationConstants';

const client = new VyjadreniaAdminCancelApi(apiConfiguration(elegislativaPrefixPath));

// eslint-disable-next-line import/prefer-default-export
export const cancelVyjadrenia = async (
  type: string,
  year: number,
  index: number,
  headers?: object,
): Promise<ClientResponse<void>> => {
  const { status } = await client.cancelVyjadrenia(type, year, index, headers);
  return {
    responseCode: status,
  };
};
